import React, { useState, useEffect } from "react"
import { useWatch } from "react-hook-form"
import { Box } from "@mui/joy"
import { useTranslation } from 'react-i18next'
import { Button, Input } from 'src/mtska-frontend-app-component'

const Constants = ({ model, control, defaultConstants = {}, onConstantsChange, setValue }) => {
    const [constants, setConstants] = useState(defaultConstants);

    useEffect(() => {
        setConstants(defaultConstants);
    }, [defaultConstants])

    useEffect(() => {
        onConstantsChange && onConstantsChange(constants);
    }, [constants]);

    const { t } = useTranslation()
    const callbackAdd = () => {
        setConstants([
            ...constants,
            {
                "field": "",
                "value": ""
            }
        ])
        //console.info('Aggiungo linea');
    }

    const callbackDelete = ({ id }) => {
        //console.info('Elimino linea ', id);

        const newConstants = constants.filter((_, index) => {
            //console.info('   Analizzo', index, parseInt(id))
            return index !== parseInt(id)
        });
        //console.info("newConstants", newConstants)
        setConstants(newConstants);
    }

    const callbackUpdate = (id, key, keyvalue) => {

        const newConstants = constants.map((constant, index) => {
            if (index === parseInt(id)) {
                return { ...constant, [key]: keyvalue }; // crea nuovo oggetto
            }
            return constant;
        });

        const hasChanged = !newConstants.every((item, i) =>
            JSON.stringify(item) === JSON.stringify(constants[i])
        );

        if (hasChanged) {
            console.info('Aggiorno linea', id, key, keyvalue);
            setConstants(newConstants);
        } else {
            console.info('NON Aggiorno linea', newConstants, constants);
        }
    }

    return (
        <>
            <Box className="importer-data-wrapper">
                <Box className="importer-data">
                    <Box className="form-element-relationship-options" sx={{ display: 'grid', gap: '30px' }}>
                        {
                            constants &&
                            Object.entries(constants).map(([id, constant]) => {
                                // necessario perché altrimenti in Constant non viene letto il valore
                                setValue('constants[' + id + '][field]', constant.field)
                                setValue('constants[' + id + '][value]', constant.value)

                                return (
                                    <Constant
                                        id={id}
                                        model={model}
                                        callbackDelete={callbackDelete}
                                        callbackUpdate={callbackUpdate}
                                        control={control}
                                    />
                                )
                            })
                        }
                        <div style={{ marginTop: 10, textAlign: 'center' }}>
                            <Button icon='faPlus' onClick={callbackAdd} title='Aggiungi'>Aggiungi</Button>
                        </div>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

const Constant = ({ id, model, control, callbackDelete, callbackUpdate }) => {
    const { t } = useTranslation()

    const getModelFieldsOptions = () => {
        const options = Array.isArray(model)
            ? model
                .filter(option => option && option.key && option.label && option.key !== 'importDestination')
                .map(option => ({ value: option.key, label: option.label }))
            : [];
        return options;
    }

    const selectedFieldWatcher = useWatch({
        control,
        name: 'constants[' + id + '][field]'
    });

    useEffect(() => {
        if (typeof selectedFieldWatcher != typeof undefined) {
            callbackUpdate(id, 'field', selectedFieldWatcher)
        }
    }, [selectedFieldWatcher]);


    const selectedValueWatcher = useWatch({
        control,
        name: 'constants[' + id + '][value]'
    });

    useEffect(() => {
        if (typeof selectedValueWatcher !== "undefined") {
            const timeout = setTimeout(() => {
                callbackUpdate(id, "value", selectedValueWatcher);
            }, 1000); // 1 secondo

            // Cleanup se l'utente digita ancora prima che scada il timeout
            return () => clearTimeout(timeout);
        }
    }, [selectedValueWatcher]);

    return (
        <Box sx={{ display: 'flex', gap: '10px' }}>
            <Box sx={{ flex: 1 }}>
                <Input
                    label={'field'}
                    type="select"
                    name={'constants[' + id + '][field]'}
                    options={getModelFieldsOptions()}
                    addEmptyOption={true}
                    control={control}
                    editing={true}
                    translateOptions={true}
                />
            </Box>
            <Box sx={{ flex: 1 }}>
                <Input
                    label={'constant value'}
                    name={'constants[' + id + '][value]'}
                    type="text"
                    placeholder={t('value')}
                    control={control}
                    editing={true}
                />
            </Box>
            <Box sx={{ flex: 1, marginTop: '30px', maxWidth: '40px' }}>
                <Button disabled={false} icon='faTrash' onClick={() => callbackDelete({ id })} title='Elimina' />
            </Box>
        </Box>
    )
}

export default Constants
